/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
#chat-item-container {
  display: flex;
  gap: 15px;
}

:host {
  width: fit-content;
  max-width: 90%;
  opacity: 0;
  transform: translateY(10px);
  animation: slideIn 0.4s ease forwards;
}

@keyframes slideIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.message-content {
  padding: 10px 16px;
}
.message-content ::slotted(ux-copy) {
  margin: 0;
}

:host([source=bot]) {
  display: block;
}
:host([source=bot]) .message-content {
  background-color: #c6d4dd;
}

:host([source=user]) .message-content {
  background-color: #fff;
}

:host([source=system]) .message-content {
  background-color: #c5c5c5;
  --ux-button-text-transform: none;
  --ux-button-font-weight: 400;
  --ux-button-border-color: #005074;
  --ux-button-text-color: #fff;
  --ux-button-bg-color: #005074;
  --ux-button-hover-bg-color: #fff;
  --ux-button-hover-border-color: #fff;
  --ux-button-hover-text-color: #000;
}
:host([source=system]) .message-content ::slotted(ux-copy) {
  margin-bottom: 10px;
}

header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.profile-picture {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 4px;
  background-color: #005074;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  overflow: hidden;
}
.profile-picture img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-message-footer {
  text-align: right;
}

.chat-name,
.chat-date {
  color: #000;
  font-size: 0.625rem;
}

@media (max-width: 768px) {
  ::slotted(#feedback-button) {
    width: 100%;
  }
}